<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Media List</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Media Table</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="top-bar">
      <div class="media">
        Show
        <el-select
            v-model="countMedia"
            @change="changeMediaCount"
            placeholder=" "
        >
          <el-option
              v-for="item in countMediaOptions"
              :key="item.value"
              :label="item.value"
              :value="item.value"
          >
          </el-option>
        </el-select>
        entries
      </div>
      <div class="add-media">
        <button type="button"
                class="el-button el-button--primary"
                @click="addMedia">
          <span>Add new</span>
        </button>
      </div>
    </div>

    <el-table
        ref="indexingTable"
        :data="media"
        style="width: 100%;"
    >
      <el-table-column label="#" type="index"></el-table-column>
      <el-table-column label="Thumbnail">
        <template slot-scope="scope">
          <img :src="scope.row.url" alt="thumbnail" style="width: 50px; height: 50px; object-fit: cover;">
        </template>
      </el-table-column>
      <el-table-column prop="original_name" label="Name">
        <template slot-scope="scope">
          {{ scope.row.original_name }}
        </template>
      </el-table-column>
      <el-table-column prop="model_dir_name" label="Uploaded to">
        <template slot-scope="scope">
          {{ scope.row.original_name }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Date">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              :status-sort="sortBy"
              title="Date"
              sort-key="created_at"
          />
        </template>
        <template slot-scope="scope">
          {{ new Date(scope.row.created_at).toLocaleString() }}
        </template>
      </el-table-column>
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <span>Actions</span>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="editMedia(scope.row)"
          >Edit
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleteMedia(scope.row)"
          >Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagin-wrp">
      <el-pagination
          :current-page="chosenPage"
          :background="true"
          layout="prev, pager, next"
          :page-size="1"
          @current-change="chosePage"
          :total="meta.last_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters} from 'vuex';
import HeaderSortTitle from "../../../../components/UsersList/HeaderSortTitle.vue";

export default {
  name: 'MediaPage',
  components: {
    HeaderSortTitle
  },
  data () {
    return {
      searchQuery: '',
      countMediaOptions: [
        {value: 10},
        {value: 25},
        {value: 50},
        {value: 100},
      ],
      countMedia: 10,
      chosenPage: 1,
      sortBy: {
        created_at: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      media: 'media/getMediaList',
      meta: 'media/getMediaMeta'
    }),
  },
  created () {
    let params = {};
    if (this.countMedia) {
      params = {
        per_page:this.countMedia,
        sort_by: 'created_at',
        sort_direction: 'DESC'
      }
    }
    this.$store.dispatch('media/getMediaList',params)
  },
  methods: {
    addMedia(){
      this.$router.push({name: 'media-create'})
    },
    changeMediaCount(count) {
      this.countMedia = count;
      this.updateMediaList()
    },
    deleteMedia(params) {
      this.$store.dispatch('media/deleteMedia', params.id)
      this.updateMediaList()
    },
    editMedia(row) {
      this.$router.push({name: 'media-edit', params: {id: row.id}})
    },
    chosePage (page) {
      this.chosenPage = page;
      this.updateMediaList()
    },
    updateMediaList() {
      const params = {};

      if (this.sortBy) {
        for (const [field, direction] of Object.entries(this.sortBy)) {
          params.sort_by = field;
          params.sort_direction = direction === 1 ? 'ASC' : 'DESC';
        }
      }
      params.per_page = this.countMedia;
      params.page = this.chosenPage;

      this.$store.dispatch('media/getMediaList', params);
    },
    sort(column) {
      this.sortBy[column] = this.sortBy[column] === 1 ? -1 : this.sortBy[column] + 1;

      this.updateMediaList();
    }
  }
}
</script>